import { render, staticRenderFns } from "./InvestorBankData.vue?vue&type=template&id=67a00acb&"
import script from "./InvestorBankData.vue?vue&type=script&lang=js&"
export * from "./InvestorBankData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports